import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { SnackbarProvider, useSnackbar } from "notistack";
import { MdClose } from "react-icons/md";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<ThemeContextProvider>
			<SnackbarProvider maxSnack={5}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</SnackbarProvider>
		</ThemeContextProvider>
	</React.StrictMode>
);
